import { BetSlipFragment } from '../graphql/core-types'
import { decodeId } from './encode-id'
import { calculatePotentialPayout, getBetOutcome, isBetNetPositive } from './bet-line-helpers'
import { LogAttributes } from './logger'

// the same bet fields on every bet event, so grafana can break any of them down by game, mode or bet type
export const betAttributes = (betSlip: BetSlipFragment): LogAttributes => {
  const firstItem = betSlip.betItems?.[0]
  return {
    betId: decodeId(betSlip.id),
    gameSlug: firstItem?.gameSlug,
    gameMode: firstItem?.gameData?.gameMode || firstItem?.gameData?.map,
    betType: firstItem?.betType,
    betItemCount: betSlip.betItems?.length ?? 0,
    wagered: betSlip.betTotalAmount,
  }
}

export const settledBetAttributes = (betSlip: BetSlipFragment): LogAttributes => ({
  ...betAttributes(betSlip),
  outcome: getBetOutcome(betSlip),
  netPositive: isBetNetPositive(betSlip),
  payout: betSlip.payout,
})

export const pendingBetAttributes = (betSlip: BetSlipFragment): LogAttributes => ({
  ...betAttributes(betSlip),
  potentialPayout: calculatePotentialPayout(betSlip),
})
